<div class="file-selected-box">
    <header>
      <h3 [innerHTML]="title"></h3>
        <div *ngIf="buttonAction" class="file-selected-button">
          <span (click)="onButtonActionClick.emit($event)"><em>{{ buttonActionText }}</em></span>
        </div>
    </header>
    <!-- Default box -->
    <div *ngIf="!file" class="file-unselected-name">
        <span><em>{{ boxDefaultText }}</em></span>
    </div>
    <!-- File item -->
    <div *ngIf="file" class="file-selected-name">
        <span><em>{{file.name}}</em> <strong title="Close" (click)="onFileActionClick.emit($event)">x</strong></span>
    </div>

</div>
